/* eslint-disable react/sort-comp */
import React from 'react';
import { makeStyles } from '@material-ui/core';
import { Button } from '@michelin/acid-components';
import { CentralProviderHeader, CurrentLocationAvatar, usePermissions } from '@michelin/central-provider';
import { runningOnCanvas } from '@michelin/central-provider/dist/utils/canvas';
import { useUIVersion } from 'contexts/UIVersionContext';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles(() => ({
  interfaceSwitcher: {
    position: 'fixed',
    top: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    height: 65,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    zIndex: 1201,
  },
}));

export function Heading() {
  const classes = useStyles();
  const { isNewUI, toggleUIVersion, featureEnabled } = useUIVersion();
  const history = useHistory();
  const permissions = usePermissions();

  const handleSwitchToLegacy = () => {
    if (!isNewUI) return;
    toggleUIVersion();
    const customerNumber = permissions.location?.customer_number;
    if (customerNumber) {
      history.push(`/${customerNumber}/all-preferences/locations`);
    }
  };

  return (
    <>
      <div style={{ display: runningOnCanvas() ? 'none' : undefined }}>
        <CentralProviderHeader
          appTitle="Michelin"
          logoType="michelin"
          customLink={
            <CurrentLocationAvatar
              allowedAccountTypes="fleet"
              allowedCountryCodes={['US', 'CA']}
              enableStateFiltering
            />
          }
          profileMenuItems={[]}
        />
        {featureEnabled && (
          <div className={classes.interfaceSwitcher}>
            <Button
              variant={isNewUI ? 'contained' : 'text'}
              color="primary"
              style={{ textTransform: 'none' }}
              onClick={() => !isNewUI && toggleUIVersion()}
            >
              New Interface
            </Button>
            <Button
              variant={!isNewUI ? 'contained' : 'text'}
              color="primary"
              style={{ textTransform: 'none' }}
              onClick={() => handleSwitchToLegacy()}
            >
              Legacy Interface
            </Button>
          </div>
        )}
      </div>
    </>
  );
}
